import { SeasonModel } from '@modules/season/season-model';

const { fields } = SeasonModel;

export default [
  fields.name,
  fields.description,
];
